import React from 'react'
import moment from 'moment'

function createCalendar(currentDate) {
  if (!currentDate) {
    currentDate = moment()
  } else {
    currentDate = moment(currentDate)
  }

  const first = currentDate.clone().startOf('month')
  const last = currentDate.clone().endOf('month')
  const weeksCount = Math.ceil((first.day() + last.date()) / 7)
  const calendar = Object.assign([], { currentDate, first, last })

  for (let weekNumber = 0; weekNumber < weeksCount; weekNumber++) {
    const week = []
    calendar.push(week)
    calendar.year = currentDate.year()
    calendar.month = currentDate.month()

    for (let day = 7 * weekNumber; day < 7 * (weekNumber + 1); day++) {
      const date = currentDate.clone().set('date', day + 1 - first.day())
      date.calendar = calendar
      week.push(date)
    }
  }
  return calendar
}

function CalendarDate(props) {
  const { dateToRender, dateOfMonth, events = [] } = props
  var startArray = events.map(function (e) {
    return moment(e.start).format('YYYY-MM-DD')
  })
  const today = dateToRender.format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') ? 'today' : ''
  const event = startArray.find((e) => e === dateToRender.format('YYYY-MM-DD'))

  if (dateToRender.month() < dateOfMonth.month()) {
    return (
      <button disabled={true} className="date prev-month">
        {dateToRender.date()}
      </button>
    )
  }

  if (dateToRender.month() > dateOfMonth.month()) {
    return (
      <button disabled={true} className="date next-month">
        {dateToRender.date()}
      </button>
    )
  }

  return (
    <button
      className={`date in-month ${today} ${event ? 'year-event' : ''}`}
      // onClick={() => props.onClick(dateToRender)}
    >
      {dateToRender.date()}
    </button>
  )
}

class Calendar extends React.Component {
  state = {
    calendar: undefined,
  }

  componentDidMount() {
    this.setState({ calendar: createCalendar(this.props.date) })
  }

  componentDidUpdate(prevProps) {
    if (this.props.date !== prevProps.date) {
      this.setState({ calendar: createCalendar(this.props.date) })
    }
  }

  render() {
    if (!this.state.calendar) {
      return null
    }

    return (
      <div className="month">
        <div className="month-name" style={{ marginLeft: '6px' }}>
          {this.state.calendar.currentDate.format('MMMM').toUpperCase()}
        </div>
        {['D', 'L', 'M', 'M', 'J', 'V', 'S'].map((day, index) => (
          <span key={index} className="day">
            {day}
          </span>
        ))}
        {this.state.calendar.map((week, index) => (
          <div key={index}>
            {week.map((date) => (
              <CalendarDate
                events={this.props.events}
                key={date.date()}
                dateToRender={date}
                dateOfMonth={this.state.calendar.currentDate}
                // onClick={(date) => this.props.onDrillDown(date, 'year')}
              />
            ))}
          </div>
        ))}
      </div>
    )
  }
}

class Year extends React.Component {
  state = {
    month: 0,
  }
  render() {
    const { date = new Date(), events = [], onDrillDown } = this.props

    const months = []
    for (let i = date.getMonth(); i < date.getMonth() + 4; i++) {
      months.push(
        <Calendar
          key={i + 1}
          date={new Date(new Date(date).getFullYear(), i, 1)}
          events={events}
          onDrillDown={onDrillDown}
        />,
      )
    }
    return (
      <div className="year" id="year">
        {months.map((month) => month)}
      </div>
    )
  }
}

Year.range = (date) => {
  return moment().startOf(date, 'year')
}

Year.navigate = (date, action, { localizer }) => {
  switch (action) {
    case 'PREV':
      return localizer.add(date, -4, 'month')

    case 'NEXT':
      return localizer.add(date, 4, 'month')

    default:
      return date
  }
}

Year.title = (date, { localizer }) => localizer.format(date, 'yearHeaderFormat')
export default Year
